export const portalNotice = {
    "title": "Hinweis zum Online Portal",
    "intro": "Unser 3D-Druck-Konfigurator ist umgezogen. Privatpersonen können weiterhin hier bestellen und ihr Konto wie gewohnt nutzen. Geschäftskunden bitten wir ab sofort, sich auf der neuen Seite erneut zu registrieren und ihre 3D-Druckaufträge hier einzureichen:",
    "cta": "Zum neuen 3D-Druck-Konfigurator",
    "thanks": "Vielen Dank für Ihr Verständnis!",
    "benefits": "Profitieren Sie von vielfältigen Optionen der Nachbearbeitung, unkomplizierte Nachbestellungen, passende Liefertermine mit Express-, Economy- oder Standard-Produktion und vieles mehr."
};
